export const PAYRATE_LOADING = "PAYRATE_LOADING";
export const PAYRATE_RESET = "PAYRATE_RESET";
export const GET_PAYRATE = "GET_PAYRATE";
export const GET_PAYRATE_SUCCESS = "GET_PAYRATE_SUCCESS";
export const GET_PAYRATE_FAIL = "GET_PAYRATE_FAIL";
export const DELETE_PAYRATE = "DELETE_PAYRATE"
export const DELETE_PAYRATE_SUCCESS = "DELETE_PAYRATE_SUCCESS"
export const DELETE_PAYRATE_FAIL = "DELETE_PAYRATE_FAIL"
export const UPDATE_PAYRATE = "UPDATE_PAYRATE"
export const UPDATE_PAYRATE_SUCCESS = "UPDATE_PAYRATE_SUCCESS"
export const UPDATE_PAYRATE_FAIL = "UPDATE_PAYRATE_FAIL"
export const ADD_NEW_PAYRATE = "ADD_NEW_PAYRATE"
export const ADD_PAYRATE_SUCCESS = "ADD_PAYRATE_SUCCESS"
export const ADD_PAYRATE_FAIL = "ADD_PAYRATE_FAIL"